import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer';

const initialState = {

}

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
});